export const modelVersion = "2.0"
export const modelVersionStage = ""
